import { SIGNALR_DEFAULTS } from './defaults';

export interface SignalRConfig {
  enableDeduplication: boolean;
  enableLogging: boolean;
  enablePerformanceMonitoring: boolean;
  messageTimeout: number;
  maxCacheSize: number;
  heartbeatInterval: number;
  reconnectStrategy: 'exponential' | 'linear' | 'fixed';
}

export const getSignalRConfig = (): SignalRConfig => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isTest = process.env.NODE_ENV === 'test';
  
  return {
    enableDeduplication: true,
    enableLogging: isDevelopment || Boolean(process.env.REACT_APP_SIGNALR_DEBUG),
    enablePerformanceMonitoring: isDevelopment,
    messageTimeout: isTest ? SIGNALR_DEFAULTS.MESSAGE_TIMEOUT_TEST : SIGNALR_DEFAULTS.MESSAGE_TIMEOUT_PROD,
    maxCacheSize: isTest ? SIGNALR_DEFAULTS.MAX_CACHE_SIZE_TEST : SIGNALR_DEFAULTS.MAX_CACHE_SIZE_PROD,
    heartbeatInterval: isTest ? SIGNALR_DEFAULTS.HEARTBEAT_INTERVAL_TEST : SIGNALR_DEFAULTS.HEARTBEAT_INTERVAL_PROD,
    reconnectStrategy: 'exponential'
  };
};

// Handle both lowercase and capitalized variants that backend sends
export const SIGNALR_EVENT_MAPPINGS = {
  // Primary events (lowercase)
  'status': 'status',
  'stream': 'stream', 
  'complete': 'complete',
  'updateSession': 'updateSession',
  'errorUpdate': 'errorUpdate',
  'activeRunsBlocked': 'activeRunsBlocked',
  'runsStatus': 'runsStatus',
  // Capitalized variants (normalize to lowercase)
  'Status': 'status',
  'Stream': 'stream',
  'Complete': 'complete',
  'UpdateSession': 'updateSession',
  'ErrorUpdate': 'errorUpdate',
  'ActiveRunsBlocked': 'activeRunsBlocked',
  'RunsStatus': 'runsStatus'
};

export const DEDUPLICATION_STRATEGIES = {
  NEVER: ['status'], // Never deduplicate
  CONTENT: ['stream'], // Content-based deduplication
  IDENTITY: ['complete', 'updateSession', 'errorUpdate', 'runsStatus', 'activeRunsBlocked'] // ID-based
};
